import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { deepOrange } from '@material-ui/core/colors';
import CloseSharpIcon from '@material-ui/icons/CloseSharp';
import RefreshSharpIcon from '@material-ui/icons/RefreshSharp';
import CallReceivedIcon from '@material-ui/icons/CallReceived';
import { Box } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
// import PropTypes from 'prop-types';
// import Rating from '@material-ui/lab/Rating';


//import { styled } from '@mui/material/styles';
import Rating from '@mui/material/Rating';

//components
import LogoAvatar from './LogoAvatar'
import { sendMessage } from '../services/WatsonService';

const CSATlabels = {
  1: 'Extremely Unsatisfied',
  2: 'Extremely Unsatisfied',
  3: 'Unsatisfied',
  4: 'Unsatisfied',
  5: 'Not Sure',
  6: 'Not Sure',
  7: 'Satisfied',
  8: 'Satisfied',
  9: 'Extremely Satisfied',
  10: 'Extremely Satisfied',
};

const NPSlabels={
  1: 'Very Unlikely',
  2: 'Very Unlikely',
  3: 'Unlikely',
  4: 'Unlikely',
  5: 'Not Sure',
  6: 'Not Sure',
  7: 'Likely',
  8: 'Likely',
  9: 'Very Likely',
  10: 'Very Likely',
};

const CESlabels={
  1: 'Great Effort',
  2: 'Great Effort',
  3: 'Effort',
  4: 'Effort',
  5: 'Neither',
  6: 'Neither',
  7: 'Some Efforts',
  8: 'Some Efforts',
  9: 'Least Effort',
  10: 'Least Effort',
}


const useStyles = makeStyles((theme) =>
  createStyles({
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {    
      flexGrow: 1,
      color: theme.palette.getContrastText(deepOrange[500]),
      fontWeight: 600,
      lineHeight: "50px",
      //fontSize: "16px",
      verticalAlign:"sub",
      

    },
    caption: {
      color:theme.palette.getContrastText(deepOrange[500]),
    },
    iconButton: {
      //color: theme.palette.getContrastText(deepOrange[500]),
    },
    appBar: {
      flexGrow: 1,
      margin: 0,
      width: "100%",
      padding:"5px 15px"
    },
    clsIcon:{
      color:"#FFF",
      lineHeight: "5!important",
      marginTop: '15px'
    },
    btn: {
      margin: theme.spacing(1),
      background: "#f26522",
      color: "#fff",
    },
    
    modalHeader:{
      textAlign: 'center', 
      color:'#fff',
      padding: "11px",
      background: "#f26522",
      borderTopLeftRadius: "7px",
      borderTopRightRadius: "7px",
    },

//PAPER is for MODAL
    paper: {
      position: 'fixed',
      transform: "translate(-50%, -50%)",
      width: "97%", //Old value was 400px
      backgroundColor: theme.palette.background.paper,
      borderBottom: "10px solid #f26522",
      boxShadow: theme.shadows[5],
      borderRadius: "10px",
      color: '#162b75',
      opacity: "0.95",
      backgroundImage: "radial-gradient(#f265227d 0.35px, #fff 0.35px)",
      backgroundSize: "7px 7px"      
    },
   
  }),
);

const Appbar = (props) => {
  const classes = useStyles();

  
  const [CSATvalue, setCSATValue] = React.useState(10);
  const [CSAThover, setCSATHover] = React.useState(-1);

  const [NPSvalue, setNPSValue] = React.useState(10);
  const [NPShover, setNPSHover] = React.useState(-1);

  const [CESvalue, setCESValue] = React.useState(10);
  const [CEShover, setCESHover] = React.useState(-1);

  //const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);

  const [rating, setRating] = React.useState([]); //Rating

  const [errMsg, setErrMsg] = React.useState();
 
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSendClicked = () => {
    let conv = props.conv;
   // console.log(conv.context.conversation_id);
    if(conv.context.conversation_id){
      if(CSATvalue && NPSvalue && CESvalue){     
        // alert("test") 
        setErrMsg("");
         setRating("Thanks for submitting your feedback!");
         sendMessage( CSATvalue+"-"+CSATlabels[CSATvalue]+'#'+NPSvalue+"-"+NPSlabels[NPSvalue]+'#'+CESvalue+"-"+CESlabels[CESvalue], conv.context)
         .then(conversation => {
           onCloseClick();
         })
         .catch(
          // error => console.log(error)
          );
       }else{
         setErrMsg("Please give all rating above then click 'Submit' or click 'Close' to exit.");
         setRating(false);
       }
    }else{
      //setErrMsg("You can't give rating until and ");
      setRating(false);
      onCloseClick();
    }
    //window.parent.document.getElementById("actionTxt").value = "close"; 
  }


  const onCloseClick = ()=>{
    window.parent.document.getElementById("actionTxt").value = "close";
    window.parent.document.getElementById("mainDiv").classList.remove('bob-open-chat-iframe');
    //let botSrc = window.parent.document.getElementById("chatIframe").src;
    //window.parent.document.getElementById("chatIframe").src = botSrc;
  }

  const onMinimiseClick = () => {
    window.parent.document.getElementById("actionTxt").value = "minimise";
    window.parent.document.getElementById("mainDiv").classList.remove('bob-open-chat-iframe');
  }

  const onRefreshClick = () =>{
    window.parent.document.getElementById("actionTxt").value = "refresh";
    let botSrc = window.parent.document.getElementById("chatIframe").src;
    window.parent.document.getElementById("chatIframe").src = botSrc;
  }


  return(
    <AppBar position="sticky" elevation={0} className={classes.appBar} >
      {/* <NeuDiv style={{padding:"5px 10px 0"}} width="100%" height="100%" radius={1} distance={props.elevate?0:0} color={deepOrange[500]}> */}
      <Box width="100%">
        <Grid container spacing={1} alignItems="stretch">
          <Grid item /*xs={2} sm={2} md={2} lg={1} xl={2}*/  style={{maxWidth: "60px!important"}} > 
            {/* <NeuDiv height="100%" radius={5}  distance={0} color={deepOrange[500]}> */}
              <LogoAvatar dark={true}/>
              <svg style={{position:"absolute", top:"40px", left:"50px"}}   width="15" height="15" viewBox="0 0 24 24" fill="green" xmlns="http://www.w3.org/2000/svg">
                <path /* fillRule="evenodd" clipRule="evenodd" */ d="M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z" fill="green" />
              </svg>
          </Grid>
          <Grid item xs={3} sm={3} md={3} lg={4} xl={3} style={{margin:'auto', marginLeft:'4px'}}>   
              <Typography variant="h5" className={classes.title} align="left">
                <Box lineHeight={2} >
                  Ask ADI
                </Box>
                {/* <Box fontSize={10} className={classes.caption} lineHeight={0} m={1}>
                    v2.1.5-beta
                </Box> */}
              </Typography>
            {/* </NeuDiv> */}
          </Grid>
          
          <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                
          </Grid>

          <Grid item>
            <RefreshSharpIcon className={classes.clsIcon} onClick={onRefreshClick}  />  
          </Grid> 
          <Grid item style={{width:"45px", maxWidth: "45px!important"}} >
            <CallReceivedIcon className={classes.clsIcon} onClick = {onMinimiseClick}  />  
          </Grid>
          <Grid item >
            {/* <CloseSharpIcon className={classes.clsIcon} onClick={handleOpen}/> */}
             <CloseSharpIcon className={classes.clsIcon} onClick={onCloseClick}/>
                
            <Modal
              disableEscapeKeyDown
              open={open}
              onClose={handleClose}
              aria-labelledby="rating-modal-title"
              aria-describedby="rating-modal-description"
            >
              <div style={{top:'50%', left:'50%'}} className={classes.paper}>
                  <h4 className={classes.modalHeader} id="rating-modal-title">It was great seeing you today !!!</h4>
                  <h5 style={{textAlign: 'center', color:'#162b75'}} >On exiting, all chat history will be cleared</h5>
                  <div id="rating-modal-description">
                    <Box component="fieldset" mb={3} borderColor="transparent" style={{textAlign: 'center'}}>
                      <Typography component="legend">How would you rate your overall experience?</Typography>
                     
                        <Rating
                          name="csat-rating"
                          defaultValue={10}
                          value={CSATvalue}
                          max={10}
                          size="large"
                          onChange={(event, newValue) => {
                            setCSATValue(newValue);
                          }}
                          onChangeActive={(event, newHover) => {
                            setCSATHover(newHover);
                          }}
                        />
                        {CSATvalue !== null && <Typography variant="button" style={{color:'green'}} display="block" gutterBottom>
                          {CSATlabels[CSAThover !== -1 ? CSAThover : CSATvalue]}
                          </Typography>}
                      
                      <hr/>
                      <Typography component="legend">How likely you would recommend Bank of Baroda to a family & friend?</Typography>
                      <Typography variant="caption" display="block" gutterBottom>On a scale of 0 to 10, with 10 being “Very Likely” and 0 being “Very Unlikely” </Typography>
                        <Rating
                          name="nps-rating"
                          defaultValue={10}
                          value={NPSvalue}
                          max={10}
                          size="large"
                          onChange={(event, newValue) => {
                            setNPSValue(newValue);
                          }}
                          onChangeActive={(event, newHover) => {
                            setNPSHover(newHover);
                          }}
                        />
                        {NPSvalue !== null && <Typography variant="button" style={{color:'green'}} display="block" gutterBottom>
                          {NPSlabels[NPShover !== -1 ? NPShover : NPSvalue]}
                          </Typography>}

                        <hr/>
                      <Typography component="legend">How much effort did it take to resolve your issue?</Typography>
                        <Rating
                          name="ces-rating"
                          defaultValue={10}
                          value={CESvalue}
                          max={10}
                          size="large"
                          onChange={(event, newValue) => {
                            setCESValue(newValue);
                          }}
                          onChangeActive={(event, newHover) => {
                            setCESHover(newHover);
                          }}
                        />
                        {CESvalue !== null && <Typography variant="button" style={{color:'green'}} display="block" gutterBottom>
                          {CESlabels[CEShover !== -1 ? CEShover : CESvalue]}
                          </Typography>}

                      <Box component="legend" align="center" id="ratingSelected" style={{color:'green', padding: '0 10px'}}> {rating} </Box>
                      <Box component="legend" align="center" id="errorMSg" style={{color:'red'}}> {errMsg} </Box>
                    </Box>
                                          
                    <Box component="fieldset" mb={3} borderColor="transparent" style={{textAlign: 'center'}}>
                      <Button variant="outlined" style={{ backgroundColor: '#f26522' }} size="small" onClick = {onSendClicked} className={classes.btn}>Submit</Button>
                      <Button variant="outlined" style={{ backgroundColor: '#f26522' }} size="small" onClick = {onCloseClick}  className={classes.btn}>Close</Button>                                  
                    </Box>
                  </div>
              </div>
            </Modal>
          </Grid>
        </Grid>
      </Box>
            
      {/* </NeuDiv> */}
      
      {/* <svg viewBox="545 0 800 165"><path fill="#fff" fill-opacity="1" d="M0,32L48,80C96,128,192,224,288,224C384,224,480,128,576,90.7C672,53,768,75,864,96C960,117,1056,139,1152,149.3C1248,160,1344,160,1392,160L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg> */}
      {/* <svg viewBox="0 0 1440 259">
        <path fill="#fff" fill-opacity="1" d="M0,32L48,80C96,128,192,224,288,224C384,224,480,128,576,90.7C672,53,768,75,864,96C960,117,1056,139,1152,149.3C1248,160,1344,160,1392,160L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
      </svg> */}
    </AppBar>
  )
}

export default Appbar;